import styled from "@emotion/styled";
import { Paper, Button, Typography } from "@mui/material";

export const MenuOption = styled(Paper)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: "0px 20px 20px 20px",
  padding: "17px 0 17px 0",
  display: "flex",
  flexDirection: "column",
}));

export const MenuButton = styled(Button)({
  borderRadius: 0,
  padding: "8px 0",
  display: "flex",
  gap: "7px",
  "&:hover": {
    opacity: 1,
    background: "transparent",
  },
  "&:active": {
    transform: "none",
  },
});

export const ArrowIconMenuButton = styled("img")(({ collapse }) => ({
  transition: "transform 0.2s",
  transform: collapse ? "rotate(180deg)" : "none",
  padding: "12px 0",
}));

export const ButtonOption = styled(Button)({
  padding: "5px 70px 5px 25px",
  borderRadius: 0,
  textTransform: "none",
  textAlign: "left",
  display: "flex",
  gap: "5px",
  justifyContent: "flex-start",
  "&:hover": {
    background: "rgba(28, 122, 217, 0.10)",
  },
});

export const TextOption = styled(Typography)({
  fontSize: "14px",
});

export const ArrowIconOption = styled("img")(({ suboption }) => ({
  width: "7px",
  height: "10px",
  transform: suboption ? "rotate(180deg)" : "rotate(-90deg)",
}));

export const TextMenuButton = styled(Typography)(
  ({ theme, selected, active }) => ({
    fontSize: "15px",
    fontWeight: 700,
    height: "80%",
    lineHeight: "36px",
    padding: "0 0",
    position: "relative",

    "&::before": {
      content: "''",
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: active ? "100%" : selected ? "100%" : "0",
      height: "2px",
      backgroundColor: theme.palette.secondary.main,
      transition: "width 0.2s ease-in-out",
      transformOrigin: selected ? "center" : "left",
    },
  })
);
